// Angular imports
import { Component, EventEmitter, Output, ViewChild } from '@angular/core';

// 3rd party imports
import { DxFormComponent } from 'devextreme-angular';
import notify from 'devextreme/ui/notify';

// CC-Common imports
import { IconConstants } from 'cc-common';

// Service imports
import { ServerErrorService } from '../../../../../_services/shared-services/server-error.service';
import { InvoiceDetailsService } from '../../../_services/account-receivable/invoice-details.service';

// Model imports
import { ARInvoiceWaiveParameterDto } from '../../../_models/account-receivable/ar-invoice/ar-invoice-waive-parameter-dto';

// Constant imports
import { MessageInterval } from '../../../../../_constants/messages-intervals';
import { Constants } from '../../../../../_constants/constants';

@Component({
    selector: 'app-waive-invoice-confirmation',
    templateUrl: './waive-invoice-confirmation.component.html',
    styleUrls: ['./waive-invoice-confirmation.component.scss']
})
export class WaiveInvoiceConfirmationComponent {
    @ViewChild('confirmForm', { static: false }) confirmForm: DxFormComponent;
    @Output() onSuccess: EventEmitter<boolean> = new EventEmitter();
    visible = false;
    loadingVisible = false;
    waiveParams: ARInvoiceWaiveParameterDto;

    iconCheck = IconConstants.CONFIRM_YES;
    iconCancel = IconConstants.CONFIRM_CANCEL;
    formLabelLocation = Constants.defaultFormLabelLocation;

    constructor(
        private readonly serverErrorService: ServerErrorService,
        private readonly invoiceDetailsService: InvoiceDetailsService
    ) {
        this.onYesClick = this.onYesClick.bind(this);
        this.onCancelClick = this.onCancelClick.bind(this);
    }

    show(invoiceId: string, selectedContext?: any): void {
        this.waiveParams = new ARInvoiceWaiveParameterDto();
        this.waiveParams.communityId = selectedContext.communityId;
        this.waiveParams.managementCompanyId = selectedContext.managementCompanyId;
        this.waiveParams.invoiceId = invoiceId;
        this.visible = true;
    }

    onShown(e): void {
        e.component.repaint();
    }

    onHidden(e): void {
        this.onCancelClick();
    }

    onYesClick(): void {
        const validator = this.confirmForm.instance.validate();
        if (validator.isValid) {
            this.loadingVisible = true;
            this.invoiceDetailsService.waiveInvoiceCharges(this.waiveParams).subscribe(
                (result) => {
                    this.loadingVisible = false;
                    if (result.isSuccessMessage) {
                        notify(
                            'Successfully waived off the invoice charges',
                            'success',
                            MessageInterval.successMsgInterval
                        );
                        this.onSuccess.emit(true);
                        this.onCancelClick();
                    } else {
                        notify('Unable to waive off the invoice charges', 'error', MessageInterval.errorMsgInterval);
                    }
                },
                (error) => {
                    this.loadingVisible = false;
                    this.serverErrorService.displayError(error);
                }
            );
        }
    }

    onCancelClick(): void {
        this.visible = false;
        this.waiveParams = null;
    }
}
